import React from 'react';
import { Table, Form, Dropdown, Input, Checkbox } from 'semantic-ui-react';
import { DateTimePicker } from 'react-widgets';

const TableRow = (props) => (
    <Table.Row disabled={props.disabled}>
        <Table.Cell textAlign="right" verticalAlign="middle">
            <b>  {props.name}</b>
        </Table.Cell>
        <Table.Cell verticalAlign="middle">
            {props.value}
        </Table.Cell>
        <Table.Cell verticalAlign="middle">
            <Form>
                {props.date || props.keyName === 'resultDate' || props.keyName === 'startDate' || props.keyName === 'endDate' || props.keyName === 'date' || props.keyName === 'registrationOpeningDate' ?
                    <Form.Field>
                        <DateTimePicker
                            format={props.keyName === 'date' ? 'D. M. YYYY. - HH:mm' : 'D. M. YYYY.'}
                            timeFormat={props.keyName === 'date' ? 'HH:mm' : null}
                            defaultValue={new Date(props.defValue)}
                            value={props.input}
                            time={props.keyName === 'date'}
                            onChange={props.handleDateChange}
                        />
                    </Form.Field>
                    : props.dropdown || props.keyName === 'canton' || props.keyName === 'orgUnit' || props.keyName === 'municipality' || props.keyName === 'entity' || props.keyName === 'country'
                    || props.keyName === 'rightType' || props.keyName === 'disabledAccess'
                    || props.keyName === 'gradedActivityName' || props.keyName === 'gradingMethod' || props.keyName === 'registrationType' ? <Form.Field>
                        <Dropdown
                                clearable
                                defaultValue={props.defValue}
                                value={props.input}
                                onChange={props.onChange}
                                name={props.keyName}
                                options={props.options}
                                compact
                                disabled={props.keyName === 'newType' || props.disabled}
                                selection
                                search
                            />
                    </Form.Field>
                        : props.type === 'checkbox' ?
                            <Form.Field>
                                <Checkbox
                                    type="checkbox"
                                    name={props.keyName}
                                    value={props.value}
                                    checked={props.checked}
                                    onChange={props.onChange}
                                    label="ograničenje na prijavu samo jednog ispita"
                                />
                            </Form.Field>
                            : <Form.Field
                                control={Input}
                                defaultValue={props.defValue}
                                value={props.input}
                                onChange={(e) => props.onChange(props.keyName, e.target.value)}
                                name="input"
                                placeholder="Unesite novi podatak"
                            />}
            </Form>
        </Table.Cell>
    </Table.Row>
);
export default TableRow;



// WEBPACK FOOTER //
// ./src/views/Admin/CreateCourse/TableRow.js